import {useLanguage} from '@/contexts/LanguageContext'

function Footer() {
  const {t} = useLanguage()

  return (
    <footer className="relative z-10 px-6 py-12 border-t border-white/10">
      <div className="max-w-5xl mx-auto text-center">
        <div className="text-2xl font-bold bg-gradient-to-r from-indigo-400 via-sky-400 to-cyan-300 bg-clip-text text-transparent mb-3">
          NYGMA
        </div>
        <p className="text-gray-500 text-sm">{t.footer.tagline}</p>
      </div>
    </footer>
  )
}

export default Footer
